import {useQuery} from '@tanstack/react-query';
import {useRequiredTenantId} from '@/matic/hooks/useRequiredTenantId';
import {getMasterDataApi} from '../api/master-data-api';
import {masterDataKeys} from '../query-keys';
import type {ObjectType, PaginatedResponse} from '../types/master-data-types';

export function useObjectTypes(
  params?: {
    search?: string;
    includeArchived?: boolean;
    limit?: number;
    offset?: number;
  },
  options?: {enabled?: boolean}
) {
  const tenantId = useRequiredTenantId();
  const api = getMasterDataApi();

  return useQuery<PaginatedResponse<ObjectType>>({
    queryKey: masterDataKeys.objectTypes(tenantId, params),
    queryFn: async () => api.listObjectTypes(params),
    enabled: options?.enabled ?? true,
  });
}
